<table   class="table table-striped display compact">
    <tbody>
    <tr>
        <td>Id</td>
        <td>
            <a [routerLink]="['/admin/study/concept/show',conceptItem.server_concept_id]">
            {{conceptItem.server_concept_id}}
            </a>
        </td>
    </tr>
    <tr>
        <td>Name</td><td>{{conceptItem.name}}</td>
    </tr>
    <tr>
        <td>Title</td> <td>{{conceptItem.title}}</td>
    </tr>
    <tr>
        <td>Description</td><td widtd="70%">{{conceptItem.description}}</td>
   </tr>

    </tbody>

</table>
<div class="text-center mt-2">
    <a [routerLink]="['/admin/study/index']" class="btn btn-primary"> <i class="fa fa-list"></i> Concept List</a>
</div>
